/**
 * Acces a `localStorage` qui ne fait jamais echouer le jeu.
 *
 * En navigation privee stricte, ou quand le quota est plein, `localStorage`
 * jette (`SecurityError`, `QuotaExceededError`). Comme l'identite du joueur en
 * depend, la moindre exception empechait le jeu de demarrer du tout. On retombe
 * donc sur une memoire volatile: la partie tourne, seule la persistance locale
 * est perdue (le serveur, lui, garde tout ce qui compte).
 */
import { journal } from './log/journal.ts'

const memoire = new Map<string, string>()
let disponible: boolean | null = null

function utilisable(): boolean {
  if (disponible !== null) return disponible
  try {
    const cle = '__essai__'
    localStorage.setItem(cle, '1')
    localStorage.removeItem(cle)
    disponible = true
  } catch {
    disponible = false
    journal.warn('stockage', 'localStorage indisponible, repli en memoire')
  }
  return disponible
}

export function lireLocal(cle: string): string | null {
  if (!utilisable()) return memoire.get(cle) ?? null
  try {
    return localStorage.getItem(cle)
  } catch {
    return memoire.get(cle) ?? null
  }
}

export function ecrireLocal(cle: string, valeur: string): void {
  memoire.set(cle, valeur)
  if (!utilisable()) return
  try {
    localStorage.setItem(cle, valeur)
  } catch (e) {
    journal.warn('stockage', `ecriture impossible pour ${cle}: ${String(e)}`)
  }
}

export function effacerLocal(cle: string): void {
  memoire.delete(cle)
  if (!utilisable()) return
  try {
    localStorage.removeItem(cle)
  } catch {
    // Sans importance: la valeur est deja retiree de la memoire.
  }
}
